import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

/** Names a template made from the form being designed; developers can also share it with every workspace. */
export function SaveTemplateDialog({ open, onOpenChange, isDeveloper, isSaving, onSave }: {
  open: boolean
  onOpenChange: (open: boolean) => void
  isDeveloper: boolean
  isSaving: boolean
  onSave: (values: { name: string; description: string; platform: boolean }) => void
}) {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [platform, setPlatform] = useState(false)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Save as template</DialogTitle>
          <DialogDescription>
            Saves the fields as they are in the designer now (unsaved changes included). Using a template later copies the
            fields; forms made from it never change when the template does.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="template-name">Name</Label>
            <Input id="template-name" value={name} maxLength={120} onChange={(e) => setName(e.target.value)} placeholder="e.g. Customer onboarding" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="template-description">Description (optional)</Label>
            <Input id="template-description" value={description} maxLength={255} onChange={(e) => setDescription(e.target.value)} />
          </div>
          {isDeveloper && (
            <label className="flex items-center gap-2 text-sm">
              <Checkbox checked={platform} onCheckedChange={(checked) => setPlatform(checked === true)} />
              Platform-wide starter (every workspace sees it)
            </label>
          )}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button disabled={!name.trim() || isSaving} onClick={() => onSave({ name: name.trim(), description: description.trim(), platform })}>
            {isSaving ? 'Saving…' : 'Save template'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
